import i18next from "i18next";
import common_en from '../../translations/en/common.json';
import common_fr from '../../translations/fr/common.json';

i18next.init({
  interpolation: { escapeValue: false },
  lng: "en", // default language
  resources: {
    en: {
      common: common_en
    },
    fr: {
      common: common_fr
    },
  },
});

export default i18next;